import NewTabLink from '@components/utils/links/newTabLink';
import { ADDITIONAL_PRODUCT } from '@constants';
import styled from '@emotion/styled';
import {
    OutboundLinkContext,
    OutboundLinkDestinationCategory,
    OutboundLinkShape,
} from '@enums';
import { useTranslation } from 'next-i18next';

interface Props {
    context: OutboundLinkContext;
    cartUrl: string;
}

const Link = styled(NewTabLink)`
    text-decoration: underline;
`;

export const AddToCartSuccessCartUrl = ({ context, cartUrl }: Props) => {
    const { t } = useTranslation(ADDITIONAL_PRODUCT, {
        keyPrefix: 'actions.add_to_cart',
    });

    return (
        <Link
            href={cartUrl}
            context={context}
            destination_name='Cart'
            destination_category={OutboundLinkDestinationCategory.Cart}
            shape={OutboundLinkShape.InlineText}
        >
            {t('see_cart')}
        </Link>
    );
};
